import React from 'react';

const PolicySection = () => {
  return (
    <section className="py-8 md:py-12 bg-black relative">
      <div className="container-custom relative z-10">
        {/* Privacy Policy */}
        <div id="privacy" className="scroll-mt-24 mb-16">
          <div className="glass-card-strong p-8 mb-8">
            <h3 className="text-2xl font-bold mb-4">Privacy Policy</h3>
            <div className="space-y-4 text-gray-300">
              <p>
                Caishen Capital Ltd. is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
              </p>
              <p>
                <strong>Information We Collect:</strong> We may collect personal information such as your name, email address, and company details when you voluntarily submit this information through our contact forms.
              </p>
              <p>
                <strong>How We Use Your Information:</strong> The information we collect is used to respond to your inquiries, improve our website, and provide you with relevant information about our services.
              </p>
              <p>
                <strong>Data Security:</strong> We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.
              </p>
              <p>
                For any questions regarding our privacy practices, please contact us at trading@caishen.capital.
              </p>
            </div>
          </div>
        </div>
        
        {/* Terms of Service */}
        <div id="terms" className="scroll-mt-24 mb-16">
          <div className="glass-card-strong p-8 mb-8">
            <h3 className="text-2xl font-bold mb-4">Terms of Service</h3>
            <div className="space-y-4 text-gray-300">
              <p>
                Welcome to Caishen Capital Ltd. By accessing our website, you agree to be bound by these Terms of Service.
              </p>
              <p>
                <strong>Website Use:</strong> The content on this website is for general information purposes only. Caishen Capital reserves the right to modify, suspend, or discontinue any aspect of the website at any time.
              </p>
              <p>
                <strong>Intellectual Property:</strong> All content on this website, including text, graphics, logos, and images, is the property of Caishen Capital Ltd. and is protected by international copyright laws.
              </p>
              <p>
                <strong>Limitation of Liability:</strong> Caishen Capital Ltd. shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services.
              </p>
              <p>
                By using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
              </p>
            </div>
          </div>
        </div>
        
        {/* Cookies Policy */}
        <div id="cookies" className="scroll-mt-24 mb-16">
          <div className="glass-card-strong p-8 mb-8">
            <h3 className="text-2xl font-bold mb-4">Cookies Policy</h3>
            <div className="space-y-4 text-gray-300">
              <p>
                Caishen Capital Ltd. uses cookies to enhance your browsing experience on our website.
              </p>
              <p>
                <strong>What Are Cookies:</strong> Cookies are small text files that are stored on your device when you visit our website. They help us analyze how users navigate our site and improve its functionality.
              </p>
              <p>
                <strong>Types of Cookies We Use:</strong>
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Essential cookies: Necessary for the website to function properly</li>
                <li>Performance cookies: Collect information about how visitors use our website</li>
                <li>Functionality cookies: Allow the website to remember choices you make</li>
              </ul>
              <p>
                <strong>Managing Cookies:</strong> You can control and manage cookies through your browser settings. However, restricting cookies may impact your experience on our website.
              </p>
              <p>
                By continuing to use our website, you consent to our use of cookies as described in this policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PolicySection;